import React from "react";
import { BalanceByService } from "../../../types";
import { Icons } from "../../shared/Icons";
import {
  BALANCE_SERVICE_BAR_COLORS,
  formatBalanceCurrency,
} from "./balanceShared";

interface BalanceByServiceCardProps {
  items: BalanceByService[];
}

export const BalanceByServiceCard: React.FC<BalanceByServiceCardProps> = ({ items }) => (
  <div className="bg-white dark:!bg-slate-800 rounded-xl sm:rounded-2xl shadow-medium border border-gray-100 dark:border-slate-700 p-3 sm:p-4 md:p-6">
    <div className="flex items-center gap-2 mb-4 sm:mb-6">
      <Icons.Label sx={{ fontSize: 22 }} className="text-gray-700 dark:text-slate-300" />
      <h3 className="text-sm sm:text-base md:text-lg font-semibold text-gray-800 dark:text-slate-100">
        Ganhos por Serviço
      </h3>
    </div>

    {items.length === 0 ? (
      <div className="bg-yellow-50 dark:bg-yellow-950/40 border border-yellow-200 dark:border-yellow-800 rounded-lg p-3 sm:p-4">
        <p className="text-xs sm:text-sm text-yellow-800 dark:text-yellow-200 text-center">
          Nenhum serviço com ganhos neste período
        </p>
      </div>
    ) : (
      <div className="space-y-3 sm:space-y-4">
        {items.map((item, index) => {
          const barColor = BALANCE_SERVICE_BAR_COLORS[index % BALANCE_SERVICE_BAR_COLORS.length];
          const countLabel =
            item.count === 1 ? "1 agendamento" : `${item.count} agendamentos`;

          return (
            <div
              key={item.serviceId}
              className="bg-gray-50 dark:!bg-slate-900 rounded-lg p-3 sm:p-4 border border-gray-200 dark:border-slate-600"
            >
              <div className="flex items-start justify-between gap-3 mb-2">
                <div className="min-w-0">
                  <p className="text-xs sm:text-sm font-medium text-gray-800 dark:text-slate-100 truncate">
                    {item.serviceName}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-slate-400 mt-0.5">{countLabel}</p>
                </div>
                <span className="text-sm sm:text-base font-bold text-gray-900 dark:text-white shrink-0">
                  {formatBalanceCurrency(item.total)}
                </span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-slate-700 rounded-full h-2">
                <div
                  className={`${barColor} h-2 rounded-full transition-all duration-300`}
                  style={{ width: `${Math.min(item.percentage, 100)}%` }}
                />
              </div>
              <p className="text-xs text-gray-500 dark:text-slate-400 mt-1">
                {item.percentage.toFixed(1)}% do total
              </p>
            </div>
          );
        })}
      </div>
    )}
  </div>
);
